"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const PdfSystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "PDF-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M17.366.007c.596 0 1.167.236 1.589.657l4.359 4.36c.42.421.658.992.658 1.588v14.343a2.994 2.994 0 0 1-2.993 2.991H3.03a2.994 2.994 0 0 1-2.996-2.992V3.004A2.994 2.994 0 0 1 3.028.007h14.338m-.878 1.5H3.028a1.495 1.495 0 0 0-1.495 1.496v17.95c0 .825.67 1.494 1.495 1.493h17.951c.824 0 1.493-.668 1.493-1.492V7.49h-3.738a2.246 2.246 0 0 1-2.24-2.091l-.005-.154V1.507m-5.98 9.722a3.742 3.742 0 0 1 3.742 3.741v1.496a3.742 3.742 0 0 1-3.742 3.742.75.75 0 0 1-.75-.75v-7.48a.75.75 0 0 1 .75-.75m8.975 0a.75.75 0 0 1 0 1.5h-1.495a.746.746 0 0 0-.746.746v2.239h1.492a.75.75 0 0 1 .744.649l.006.101a.75.75 0 0 1-.75.75h-1.493v2.244a.75.75 0 0 1-.648.743l-.101.007a.75.75 0 0 1-.75-.75v-2.98l-.001-.014V13.475a2.246 2.246 0 0 1 2.247-2.246Zm-14.96-.002h.03l.719.002a2.994 2.994 0 0 1 0 5.987l.001 2.24a.75.75 0 0 1-.648.743l-.102.007a.75.75 0 0 1-.75-.75v-7.48a.75.75 0 0 1 .75-.75m6.735 1.63v5.723a2.243 2.243 0 0 0 1.492-2.114V14.97c0-.975-.623-1.804-1.492-2.113m-5.986-.13.001 2.99a1.494 1.494 0 0 0-.001-2.988v-.001M22.158 5.99l-4.17-4.171v3.426c0 .377.281.69.645.739l.101.007 3.424-.001"
  })));
};
PdfSystemIcon.displayName = "PdfSystemIcon";
PdfSystemIcon.iconName = "Pdf";
export default PdfSystemIcon;